import { render, staticRenderFns } from "./progress-prioritization-column.vue?vue&type=template&id=05c0d7ed&"
import script from "./progress-prioritization-column.vue?vue&type=script&lang=js&"
export * from "./progress-prioritization-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports